import {EamHeroMapLazy} from 'app/components/eamHeroMap/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineEamHeroMap(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-eam-hero-map')) {
        return;
    }

    customElements.define(
        'gem-eam-hero-map',
        class extends WebComponentLoader {
            reactLazyComponent = EamHeroMapLazy;
        },
    );
}
